import {
  UpdatePatientDemographicsDetailsState,
  UpdateDemographicsDetailsActionTypes,
  UPDATE_PATIENT_DEMOGRAPHICS_LOADING,
  UPDATE_PATIENT_DEMOGRAPHICS_SUCCESS,
  UPDATE_PATIENT_DEMOGRAPHICS_FAIL,
  UPDATE_PATIENT_DEMOGRAPHICS_UPDATE_API_MSG,
  UPDATE_PATIENT_DEMOGRAPHICS_UPDATE_API_RES,
} from "./ActionTypes";
import { UpdateDemographicsDetailsByPatientIdRes } from "./Model";

const initialStateGetPosts: UpdatePatientDemographicsDetailsState = {
  loading: false,
  updatePatientDemographicsRes: {} as UpdateDemographicsDetailsByPatientIdRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const updateDemographicsDetailsByPatientIdReducer = (
  state = initialStateGetPosts,
  action: UpdateDemographicsDetailsActionTypes
): UpdatePatientDemographicsDetailsState => {
  switch (action.type) {
    case UPDATE_PATIENT_DEMOGRAPHICS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case UPDATE_PATIENT_DEMOGRAPHICS_SUCCESS:
      return {
        ...state,
        updatePatientDemographicsRes: action.payload,
        successMsg: action.successMsg,
      };
    case UPDATE_PATIENT_DEMOGRAPHICS_FAIL:
      return {
        ...state,
        updatePatientDemographicsRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case UPDATE_PATIENT_DEMOGRAPHICS_UPDATE_API_MSG:
      return {
        ...state,
        updatePatientDemographicsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case UPDATE_PATIENT_DEMOGRAPHICS_UPDATE_API_RES:
      return {
        ...state,
        updatePatientDemographicsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
